import { ReactNode, useEffect, useState } from 'react';

type Props = {
  children: ReactNode
}

// Based on https://stackoverflow.com/a/45579284/11643 - this component tries
// to ensure that its children are always cleanly unmounted (and useEffect
// cleanup functions run) even when the browser window is closed.
export const GracefulUnmount = ({ children }: Props) => {

  const [mounted, setMounted] = useState<boolean>(true);

  useEffect(
    () => {
      const handleBeforeUnload = () => {
        setMounted(false);
      };

      window.addEventListener('beforeunload', handleBeforeUnload);

      return () => {
        window.removeEventListener('beforeunload', handleBeforeUnload);
      };
    },
    []
  );

  if (!mounted) {
    return null;
  }

  return children;
};
